var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Route } from "react-router-dom";
import { Button, Dimmer, Form, Grid, Loader } from "semantic-ui-react";
import { RnaCatalogType } from "../../admin/EditOrderKit";
import { consumerConfigurations, Plexity, ProKitConfig } from "../../KitDeserializer";
import { CatalogMode } from "../../RequestHelpers";
import { buildEditFormStateHandlerForComponent } from "../FormState";
import { CART_PRICE_PATH } from "../rna-fish/EditKitForm";
import { LoadWrapper } from "../rna-fish/LoadWrapper";
import { addToCartHandlerBuilder } from "../rna-fish/NewRnaFishKitPage";
import EditKitForm, { ProtocolTypeEnum } from "./EditKitForm";
import { RnaCishEditableOrganism, RnaCishEditableTarget } from "./ProbeSetForm";
import { RelevantCatalogType } from "./RnaCatalog";
import { RnaCatalogLoader } from "./RnaCatalogLoader";
var NewMultiPlexProKitPage = /** @class */ (function (_super) {
    __extends(NewMultiPlexProKitPage, _super);
    function NewMultiPlexProKitPage(props) {
        return _super.call(this, props) || this;
    }
    NewMultiPlexProKitPage.prototype.render = function () {
        var _this = this;
        var rendererFn = function (catalog) { return React.createElement(React.Fragment, null,
            React.createElement(NewMultiPlexKitContent, { catalog: catalog, admin: _this.props.admin })); };
        return React.createElement(React.Fragment, null,
            React.createElement(LoadWrapper, { loader: new RnaCatalogLoader(CatalogMode.Consumer, RelevantCatalogType.Initial, RnaCatalogType.RnaCish), render: rendererFn }));
    };
    return NewMultiPlexProKitPage;
}(React.PureComponent));
export default NewMultiPlexProKitPage;
var NewMultiPlexKitContent = /** @class */ (function (_super) {
    __extends(NewMultiPlexKitContent, _super);
    function NewMultiPlexKitContent(props) {
        var _this = _super.call(this, props) || this;
        _this.onAddToCart = addToCartHandlerBuilder(function (callback) {
            _this.setState({
                loading: true
            }, callback);
        }, function () { return JSON.stringify(EditKitForm.serializeMultiPlexProKit(_this.state.formState)); }, function (history) {
            _this.setFormState(function () { return ({
                errors: [],
            }); }, function () {
                _this.setState({
                    loading: false,
                }, function () {
                    history.push('/cart');
                });
            });
        }, function (errors) {
            _this.setFormState(function () { return ({
                errors: errors.errors,
            }); }, function () {
                _this.setState({
                    loading: false,
                });
            });
        });
        _this.setFormState = buildEditFormStateHandlerForComponent('formState', _this);
        _this.addToCartButton = function (props) {
            var onClick = function () {
                _this.onAddToCart(props.history);
            };
            return React.createElement(Button, { disabled: _this.disableAddToCartButton(), className: 'cish-button', icon: 'cart plus', label: "Add To Cart", labelPosition: "left", onClick: onClick, positive: true });
        };
        _this.disableAddToCartButton = function () {
            var formState = _this.state.formState;
            if (formState.kitConfiguration == null) {
                return true;
            }
            if (formState.protocolType == null || formState.scale == null) {
                return true;
            }
            var invalidProbe = !formState.proKitProbeState.every(function (state) {
                return state.state.organism.name.trim() !== "" &&
                    state.state.target.name !== "";
            });
            var invalidDetect = !formState.proKitDetectState.every(function (state) {
                return state.state.enzymeCompatibility != null;
            });
            if (formState.kitConfiguration === ProKitConfig.ProbeDetect) {
                return invalidProbe || invalidDetect;
            }
            if (formState.kitConfiguration === ProKitConfig.ProbeOnly) {
                return invalidProbe;
            }
            if (formState.kitConfiguration === ProKitConfig.DetectOnly) {
                return invalidDetect;
            }
            return false;
        };
        _this.state = {
            loading: false,
            formState: defaultMultiPlexFormState(_this.props.catalog)
        };
        return _this;
    }
    NewMultiPlexKitContent.prototype.render = function () {
        var _a;
        return React.createElement(Dimmer.Dimmable, { id: "non-header-portion", className: "enzymatic-ish-form", as: Form, error: this.state.formState.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(EditKitForm, { kitPriceUrlPath: CART_PRICE_PATH, catalog: this.props.catalog, kitConfigurations: consumerConfigurations, formState: this.state.formState, loadPriceOnMount: false, setFormState: this.setFormState }),
            ((_a = this.state.formState.protocolType) === null || _a === void 0 ? void 0 : _a.id) !== ProtocolTypeEnum.BOND_III &&
                React.createElement(Grid, { columns: 1, textAlign: "right" },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 3 }),
                        React.createElement(Grid.Column, { width: 12 },
                            React.createElement(Route, { render: this.addToCartButton })))));
    };
    return NewMultiPlexKitContent;
}(React.PureComponent));
export var defaultMultiPlexFormState = function (catalog) {
    var ampCatalog = catalog.proAmplifier;
    var defaultAmp = ampCatalog.oneTargetProAmps.proAmpConfigList[0].amplifier;
    return {
        kitConfiguration: ProKitConfig.ProbeDetect,
        plexity: Plexity.OnePlex,
        prefilled: false,
        protocolType: undefined,
        scale: undefined,
        amplifierCatalog: ampCatalog.oneTargetProAmps,
        proKitProbeState: [
            {
                state: defaultProKitProbeFormState(defaultAmp),
                channel: 1,
                metadata: undefined
            }
        ],
        proKitDetectState: [
            {
                state: defaultProKitDetectFormState(),
                channel: 1,
                metadata: undefined
            }
        ],
        errors: [],
        price: undefined,
        priceLoading: false,
        comment: "",
        addedSecondTarget: false,
        chromogenPresetScale: undefined,
        detectPresetScale: undefined
    };
};
export var defaultProKitProbeFormState = function (defaultAmp) {
    return {
        organism: RnaCishEditableOrganism.default(),
        target: RnaCishEditableTarget.default(0),
        probeSetFamilies: [],
        searchQuery: "",
        searchLoading: false,
        hcrAmplifier: defaultAmp,
        enableCustomTarget: true
    };
};
export var defaultProKitDetectFormState = function () {
    return {
        chromogen: undefined,
        enzymeCompatibility: undefined
    };
};
//# sourceMappingURL=NewMultiPlexProKitPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/NewMultiPlexProKitPage.js
// module id = 132
// module chunks = 0